import React from "react";
import { Dimensions } from "react-native";
import Image from "@components/common/Image";
import { View } from "react-native-animatable";
import Svg, { Rect } from "react-native-svg";

const { width } = Dimensions.get("screen");

const ProductSkeleton = () => {
  return (
    <View
      animation="fadeIn"
      useNativeDriver
      style={{
        paddingVertical: 6,
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <View
        style={{
          backgroundColor: "#f5f5f5",
        }}
      >
        <Image
          source={require("../../../assets/images/product-placeholder.webp")}
          style={{ height: 64, width: 64, margin: 36, paddingLeft: 15 }}
        />
      </View>
      <Svg width="100%" height={120} viewBox={`${width / 3} 0 ${width} 120`}>
        <Rect
          x={width / 3}
          y="0"
          rx="2"
          ry="2"
          width={230}
          height="25"
          fill="#c5c5c5"
        />
        <Rect
          x={width / 3}
          y="40"
          rx="2"
          ry="2"
          width={150}
          height="15"
          fill="#c5c5c5"
        />
        <Rect
          x={width / 3}
          y="70"
          rx="2"
          ry="2"
          width={180}
          height="30"
          fill="#c5c5c5"
        />
      </Svg>
    </View>
  );
};

export default ProductSkeleton;
